import {
  GetNotificationsResponse,
  UpdateNotificationResponse,
} from "@/dto/get-notification.dto";
import { api } from "@/lib/api";

export const notficationApi = {
  getNotifications: async (): Promise<GetNotificationsResponse> => {
    const response = await api.get<GetNotificationsResponse>("notifications");
    return response.data;
  },
  updateNotification: async (
    notificationId: string,
    read: boolean
  ): Promise<UpdateNotificationResponse> => {
    const response = await api.patch<UpdateNotificationResponse>(
      "notifications",
      {
        notificationId,
        read,
      }
    );
    return response.data;
  },
  deleteNotification: async (
    notificationId: string
  ): Promise<{ success: boolean }> => {
    const response = await api.delete(`notifications/${notificationId}`);
    return response.data;
  },
  clearAllNotifications: async (): Promise<{ success: boolean }> => {
    const response = await api.delete("notifications/all");
    return response.data;
  },
};
